import moment from 'moment-timezone';

export const locationClosings = (state, rootState, getters, rootGetters) => locationId => {
  return rootGetters['entities/StationTemporaryClosing'](closing => closing.location === locationId);
};

export const stationClosings = (state, rootState, getters, rootGetters) => stationId => {
  return rootGetters['entities/StationTemporaryClosing'](closing => closing.station === stationId);
};

export const locationClosingsOnDate = (state, rootState, getters, rootGetters) => ({ locationId, date }) => {
  const dateMoment = moment(date);
  const startOfDay = dateMoment.set({
    hour: 0,
    minute: 0,
    second: 0,
  }).valueOf();
  const endOfDay = dateMoment.add(1, 'day').set({
    hour: 0,
    minute: 0,
    second: 0,
  }).valueOf();

  return locationClosings(state, rootState, getters, rootGetters)(locationId).filter(closing => {
    const startTime = moment(closing.startTime).valueOf();
    const endTime = moment(closing.endTime).valueOf();

    return startTime < endOfDay && endTime > startOfDay;
  });
};

export const closingById = (state, rootState, getters, rootGetters) => closingId => {
  return rootGetters['entities/StationTemporaryClosing'](closingId);
};
